export * as data from '@wix/auto_sdk_data-resourceusage-service_data/meta';
